document.querySelectorAll('[data-hao-product-form]').forEach((container) => {
  const select = container.querySelector('[data-hao-variant-select]');
  if (!select) return;

  const form = container.closest('.hao-product__summary');
  const price = form?.querySelector('[data-hao-variant-price]');
  const stock = form?.querySelector('[data-hao-variant-stock]');
  const submit = container.querySelector('button[name="add"]');

  select.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    if (!option) return;

    const eligible = option.dataset.eligible === 'true';
    const available = option.dataset.available === 'true';
    if (price) {
      price.textContent = option.dataset.price || '';
      price.hidden = !option.dataset.price;
    }
    if (stock) {
      stock.textContent = eligible ? (stock.dataset.inStockLabel || 'Available') : available ? 'Not currently available' : 'Sold out';
      stock.classList.toggle('hao-stock--out', !eligible);
    }
    if (submit) {
      submit.disabled = !eligible;
      submit.textContent = eligible ? 'Add to cart' : available ? 'Unavailable' : 'Sold out';
    }
    if (option.dataset.url) window.history.replaceState({}, '', option.dataset.url);

    if (option.dataset.mediaId) {
      const media = document.querySelector(`[data-hao-product-media-id="${option.dataset.mediaId}"]`);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      media?.scrollIntoView({ block: 'nearest', behavior: reducedMotion ? 'auto' : 'smooth' });
    }
  });
});
